import { useSyncExternalStore } from 'react';
import { syncStatus, type SyncState } from './status.js';

const SERVER_SNAPSHOT: SyncState = {
  online: true,
  phase: 'idle',
  pending: 0,
  failed: 0,
  conflicts: 0,
  lastPullAt: null,
  lastError: null,
  bootstrapped: false,
};

export function useSyncState(): SyncState {
  return useSyncExternalStore(syncStatus.subscribe, syncStatus.get, () => SERVER_SNAPSHOT);
}

export function useOnlineStatus(): boolean {
  return useSyncState().online;
}
